import React from 'react';
import {Button, Modal as AntModal, ModalProps, Row} from 'antd';
import { useProcedure } from '@/@presentation/modules/procedure/context/procedure';

interface IModal extends Omit<ModalProps, 'onOk' | 'onCancel'> {
    visible: boolean
    children: React.ReactNode;
    title: string;
    handleOk: () => void;
    loading: boolean;
    handleCancel: () => void;
    paymentCustomerName: string
    paymentCustomerNationality: string
    paymentCustomerRne: string
}

const ModalConfirmationNf: React.FC<IModal> = (props) => {        
    const { states } = useProcedure();

    // Função para buscar o nome completo do país usando os dados do contexto
    const getCountryName = (countryCode: string): string => {
        if (!countryCode) return 'Não informado';
        
        const nationalityOption = states.nationality?.find(option => 
            option.sigla?.toUpperCase() === countryCode.toUpperCase() || 
            option.nome_pais?.toUpperCase() === countryCode.toUpperCase()
        );
        
        return nationalityOption?.nome_pais || countryCode.toUpperCase();
    };

    return (
        <AntModal
            data-testid="modal-form"
            destroyOnClose={true}
            forceRender
            title={props.title}
            open={props.visible}
            centered={true}
            onOk={props.handleOk}
            onCancel={props.handleCancel}
            width={700}
            footer={[
                <Button key="back" data-testid="modal-form-btn-cancel" style={{borderColor: '#de1010', color: '#de1010'}} onClick={props.handleCancel}>
                    Cancelar
                </Button>,
                <Button key="back" loading={props.loading} data-testid="modal-form-btn-cancel" style={{backgroundColor: '#298f46', color: '#fff'}} onClick={props.handleOk}>
                    Confirmar
                </Button>
            ]}
        >
            <Row>
                <p>Os dados do tomador estão corretos para a emissão da Nota Fiscal? <br />
                Garanta que os dados de endereço estejam completos antes de emitir.</p>
            </Row>
            <Row>
                <p style={{ marginTop: 10, fontSize: 15, marginRight: 10, fontWeight: '700'}}>Tomador:</p>
                <p style={{ marginTop: 10, fontSize: 16}}>{props.paymentCustomerName.toUpperCase()}</p>
                <p style={{ marginTop: 10, fontSize: 15, marginRight: 10, marginLeft: 10, fontWeight: '700'}}>Nacionalidade:</p>
                <p style={{ marginTop: 10, fontSize: 16}}>{getCountryName(props.paymentCustomerNationality)}</p>
            </Row>
            <Row>
                <p style={{ marginTop: 10, fontSize: 15, marginRight: 10, fontWeight: '700'}}>RNE/Passaporte:</p>
                <p style={{ marginTop: 10, fontSize: 16}}>{props.paymentCustomerRne}</p>
            </Row>
        </AntModal>
    );
};

export {ModalConfirmationNf};
